import { API_ROOT } from '../../config/config'

//const API_ROOT = 'http://localhost/api'

import { doGet, doPut } from './utils'

export const getChangeSubProjectStatusPage = (projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/project-status-change?projectVersionId=${projectVersionId || ''}&projectCode=${projectCode || ''}`
  return doGet(url)
}

export const updateChangeSubProjectStatus = (projectVersionId, request, projectCode) => {
  const url = `${API_ROOT}/subproject/project-status-change?projectVersionId=${projectVersionId || ''}&projectCode=${projectCode || ''}`
  return doPut(url, request)
}
